import * as React from "react";
import { toINR } from "../../../../service/numberFormat";
import { marginFnoHeading } from "../../marginConstants";
import { ISortProps } from "../../../../types/components/margin/marginTypes";
import MarginSort from "../../generic/marginSort";
import NoDataContainer from "../../../../generic/noDataContainer";

export interface IMarginFnoTableDskProps {
	tableData: Array<any>;
	filteredData: Array<any>;
	numOfRows: number;
	sortProps: ISortProps;
	setTableData: (tableData: Array<any>) => void;
}

const MarginFnoTableDsk: React.FC<IMarginFnoTableDskProps> = props => {
	return (
		<div className="mrgn_fno_tbl table">
			<ul className="hdr_row">
				<li className="tr">
					<div className="td trdSym">
						<span className="sort_cont">
							<MarginSort
								sortList={props.filteredData}
								sortedColName={props.sortProps.sortedColumnState.colName}
								sortKey="trdSym"
								onSort={props.sortProps.onSort}
								colName={marginFnoHeading.trdSym}
							/>
						</span>
					</div>
					<div className="td Mlot">
						<span className="sort_cont">
							<MarginSort
								sortList={props.filteredData}
								sortedColName={props.sortProps.sortedColumnState.colName}
								sortKey="Mlot"
								onSort={props.sortProps.onSort}
								colName={marginFnoHeading.mlot}
							/>
						</span>
					</div>
					<div className="td SpanMarginPerLot right">
						<span className="sort_cont">
							<MarginSort
								sortList={props.filteredData}
								sortedColName={props.sortProps.sortedColumnState.colName}
								sortKey="SpanMarginPerLot"
								onSort={props.sortProps.onSort}
								colName={marginFnoHeading.spanMarginPerLot}
							/>
						</span>
					</div>
					<div className="td ExpMarginPerLot right">
						<span className="sort_cont">
							<MarginSort
								sortList={props.filteredData}
								sortedColName={props.sortProps.sortedColumnState.colName}
								sortKey="ExpMarginPerLot"
								onSort={props.sortProps.onSort}
								colName={marginFnoHeading.expMarginPerLot}
							/>
						</span>
					</div>
					<div className="td TotalMarginPerLot right">
						<span className="sort_cont">
							<MarginSort
								sortList={props.filteredData}
								sortedColName={props.sortProps.sortedColumnState.colName}
								sortKey="TotalMarginPerLot"
								onSort={props.sortProps.onSort}
								colName={marginFnoHeading.totalMarginPerLot}
							/>
						</span>
					</div>
					<div className="td RoundOff right">
						<span className="sort_cont">
							<MarginSort
								sortList={props.filteredData}
								sortedColName={props.sortProps.sortedColumnState.colName}
								sortKey="RoundOff"
								onSort={props.sortProps.onSort}
								colName={marginFnoHeading.roundOff}
							/>
						</span>
					</div>
				</li>
			</ul>

			{props.tableData.length ? (
				<ul className="mrgn_scrl_cont data_rows">
					{props.tableData.slice(0, props.numOfRows).map((row, index) => (
						<React.Fragment key={index}>
							<li className="tr">
								<div className="td trdSym robotoM">
									<span dangerouslySetInnerHTML={{ __html: row.trdSym }}></span>
								</div>
								<div className="td Mlot">{toINR(row.Mlot)}</div>
								<div className="td SpanMarginPerLot right">
									{toINR(row.SpanMarginPerLot)}
									<br />
									<span className="row_2">{toINR(row.SPANMarginper)}%</span>
								</div>
								<div className="td ExpMarginPerLot right">
									{toINR(row.ExpMarginPerLot)}
									<br />
									<span className="row_2">{toINR(row.ExpMarginper)}%</span>
								</div>
								<div className="td TotalMarginPerLot right">
									{toINR(row.TotalMarginPerLot, 2)}
									<br />
									<span className="row_2">{toINR(row.TotalMarginper)}%</span>
								</div>
								<div className="td RoundOff right">{toINR(row.RoundOff)}</div>
							</li>
						</React.Fragment>
					))}
				</ul>
			) : (
				<NoDataContainer txtHeading="No results found" />
			)}
		</div>
	);
};

export default MarginFnoTableDsk;
